import type { ButtonProps, ButtonVariant } from "./ButtonProps.js";

export function generateButtonClasses({ variant, disabled }: ButtonProps): string {
	const btnVariants: Record<ButtonVariant, string> = {
		primary:
			"font-roboto font-medium text-sm lg:text-base tracking-wider group bg-ltprimary-300 text-white rounded-full h-10 lg:h-12 border-0",
		underline:
			"font-semibold hover:!underline hover:text-ltprimary-100 active:!underline active:text-ltprimary-100 text-sm lg:text-base tracking-wider group bg-ltprimary-300 text-white rounded-full h-10 lg:h-12 border-0",
		secondary:
			"font-roboto font-medium text-sm lg:text-base tracking-wider group text-ltprimary-300 hover:text-white active:text-white border-1 border-ltprimary-300 rounded-full h-10 lg:h-12",
		primaryTransparent:
			"font-roboto font-medium text-sm lg:text-base tracking-wider group bg-white text-ltprimary-300 rounded-full h-10 lg:h-12 border-0",
		secondaryTransparent:
			"font-roboto text-sm lg:text-base tracking-wider group text-white hover:text-ltprimary-100 active:text-ltprimary-100 h-10 lg:h-12 border-1 border-white rounded-full",
		tertiary:
			"group text-xs lg:text-base flex items-center text-ltprimary-300 font-normal hover:text-ltprimary-100 active:text-ltprimary-100",
		whiteTertiary:
			"group text-xs lg:text-base flex items-center text-white underline font-normal hover:text-[#CDC7FF] active:text-[#CDC7FF]",
		active: "",
		custom: "",
	};
	const variantClass = btnVariants[variant ?? "primary"];

	const disabledClass = disabled && "opacity-50 pointer-events-none";

	if (variant !== "tertiary" && variant !== "whiteTertiary") {
		return [
			"rounded-[.65rem] flex gap-4 items-center no-underline border px-4 pt-3.5 pb-[.8rem] transition-all duration-300 tracking-[0.075rem] uppercase text-2xs/[1.35] w-fit cursor-pointer relative",
			variantClass,
			disabledClass,
		]
			.filter(Boolean)
			.join(" ");
	}

	return [variantClass, disabledClass].filter(Boolean).join(" ");
}
